import styles from "./index.module.less";
import imgCover from "../../imgs/cover.png";
import classNames from "classnames";
import PlayIcon from "../../imgs/play.png";
import { useState } from "react";
import VideoModal from "@/components/VideoModal";
import { Typography } from "antd";

const {Paragraph} = Typography
const SolutionCard = ({
  company,
  title,
  desc,
  img,
  video,
  poster,
  index = 0,
  anchor = "",
  id,
}: {
  company?: string;
  title?: string;
  desc?: string;
  img?: string;
  video?: string;
  poster?: string;
  index?: number;
  anchor?: string;
  id?: string;
}) => {
  const [open, setOpen] = useState(false);
  return (
    <div
      className={styles.card}
      id={`solution-${anchor}`}
      title={title}
    >
      <div className={styles.left}>
        <img className={styles.img} src={img} alt={title} />
        <img className={styles.imgCover} src={imgCover} />

        {video && (
          <div
            className={styles.videoContainer}
            onClick={() => {
              setOpen(true);
            }}
          >
            <video
              className={styles.video}
              src={video}
              poster={img}
              controls={false}
            />
            <img className={styles.playBtn} src={PlayIcon} />
          </div>
        )}
      </div>
      <div className={styles.right}>
        <div className={styles.index}>{index + 1 > 9 ? index + 1 : `0${index + 1}`}</div>
        <div className={styles.content}>
          {company && <div className={styles.company}>{company}</div>}
          {title && <div className={styles.title}>{title}</div>}
          {desc && <Paragraph className={styles.desc} ellipsis={{
                rows: 100,
                expandable: false,
            }}>{desc}</Paragraph>}
        </div>
      </div>
      <VideoModal open={open} onClose={() => setOpen(false)} url={video} />
    </div>
  );
};
export default SolutionCard;
